<app-document
  *ngIf="clntSeq"
  [entitySeq]="crptOnbrdngSeq ?? clntSeq"
  [moduleSeq]="MODULE_SEQ.ONBOARDING">
</app-document>

<!-- EMPTY -->
<div
  *ngIf="!clntSeq"
  class="text-center text-gray-500 p-8"
>
  {{ 'ONB_DOCUMENTS.CLIENT_INFO_MISSING' | translate }}
</div>

<!-- CONTINUE -->
<div
  *ngIf="clntSeq"
  class="flex justify-end mt-6"
>

  <button
    (click)="goNext()"
    class="bg-indigo-600 text-white px-6 py-2 rounded-lg font-semibold"
  >
    {{ 'COMMON.CONTINUE' | translate }}
  </button>

</div>